import {FiAlertTriangle} from "react-icons/fi";

import {TwoLineShortDateTimeUser} from "@/components/datetime/TwoLineShortDateTimeUser.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {AccountUser} from "@/lib/types/accounts.ts";
import {MaintenanceOccurrence} from "@/lib/types/maintenance.ts";

export const ActiveOccurrenceEnds = ({occurrence, user}: {occurrence: MaintenanceOccurrence; user: AccountUser}) => {
  if (!occurrence.ends_at) {
    return (
      <span className={"d-flex align-items-center gap-1 pulseTextBodySmall pulse-color-orange-600"}>
        <Icon icon={FiAlertTriangle} />
        <span>No end set</span>
      </span>
    );
  }

  return <TwoLineShortDateTimeUser date={occurrence.ends_at} user={user} />;
};
